import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/index.css";
import App from "@/App";
import QuickCompress from "@/pages/QuickCompress";
import QuickCompress100 from "@/pages/QuickCompress100";
import QuickCompress200 from "@/pages/QuickCompress200";
import QuickCompress500 from "@/pages/QuickCompress500";
import QuickCompress1MB from "@/pages/QuickCompress1MB";
import WhatsAppCompress from "@/pages/WhatsAppCompress";
import ResizeImage50KB from "@/pages/ResizeImage50KB";
import ResizeImage100KB from "@/pages/ResizeImage100KB";
import ResizeImage200KB from "@/pages/ResizeImage200KB";
import ResizeImage2MB from "@/pages/ResizeImage2MB";
import ResizeImage300x300 from "@/pages/ResizeImage300x300";
import ResizeForWhatsApp from "@/pages/ResizeForWhatsApp";
import ConvertJpgToPng from "@/pages/ConvertJpgToPng";
import ConvertPngToJpg from "@/pages/ConvertPngToJpg";
import ConvertPngToWebp from "@/pages/ConvertPngToWebp";
import ConvertJpgToWebp from "@/pages/ConvertJpgToWebp";
import ConvertPngToBmp from "@/pages/ConvertPngToBmp";
import ConvertPngToTiff from "@/pages/ConvertPngToTiff";
import ConvertPngToIco from "@/pages/ConvertPngToIco";
import ConvertJpgToJpeg from "@/pages/ConvertJpgToJpeg";
import ConvertJpgToBmp from "@/pages/ConvertJpgToBmp";
import ConvertJpgToTiff from "@/pages/ConvertJpgToTiff";
import ConvertJpgToIco from "@/pages/ConvertJpgToIco";
import ConvertBmpToPng from "@/pages/ConvertBmpToPng";
import ConvertBmpToJpg from "@/pages/ConvertBmpToJpg";
import ConvertBmpToJpeg from "@/pages/ConvertBmpToJpeg";
import ConvertBmpToTiff from "@/pages/ConvertBmpToTiff";
import ConvertBmpToWebp from "@/pages/ConvertBmpToWebp";
import ConvertBmpToIco from "@/pages/ConvertBmpToIco";
import ConvertTiffToPng from "@/pages/ConvertTiffToPng";
import ConvertTiffToJpg from "@/pages/ConvertTiffToJpg";
import ConvertTiffToJpeg from "@/pages/ConvertTiffToJpeg";
import ConvertTiffToBmp from "@/pages/ConvertTiffToBmp";
import ConvertTiffToWebp from "@/pages/ConvertTiffToWebp";
import ConvertTiffToIco from "@/pages/ConvertTiffToIco";
import ConvertWebpToPng from "@/pages/ConvertWebpToPng";
import ConvertWebpToJpg from "@/pages/ConvertWebpToJpg";
import ConvertWebpToJpeg from "@/pages/ConvertWebpToJpeg";
import ConvertWebpToBmp from "@/pages/ConvertWebpToBmp";
import ConvertWebpToTiff from "@/pages/ConvertWebpToTiff";
import ConvertWebpToIco from "@/pages/ConvertWebpToIco";
import ConvertIcoToPng from "@/pages/ConvertIcoToPng";
import ConvertIcoToJpg from "@/pages/ConvertIcoToJpg";
import ConvertIcoToJpeg from "@/pages/ConvertIcoToJpeg";
import ConvertIcoToBmp from "@/pages/ConvertIcoToBmp";
import ConvertIcoToTiff from "@/pages/ConvertIcoToTiff";
import ConvertIcoToWebp from "@/pages/ConvertIcoToWebp";
import ConvertHeicToJpg from "@/pages/ConvertHeicToJpg";
import ConvertHeicToPng from "@/pages/ConvertHeicToPng";
import ConvertHeicToBmp from "@/pages/ConvertHeicToBmp";
import ConvertHeicToTiff from "@/pages/ConvertHeicToTiff";
import ConvertHeicToIco from "@/pages/ConvertHeicToIco";
import ConvertHeicToWebp from "@/pages/ConvertHeicToWebp";
import ConvertHeicToSvg from "@/pages/ConvertHeicToSvg";
import ConvertSvgToPng from "@/pages/ConvertSvgToPng";
import ConvertSvgToJpg from "@/pages/ConvertSvgToJpg";
import ConvertSvgToBmp from "@/pages/ConvertSvgToBmp";
import ConvertSvgToTiff from "@/pages/ConvertSvgToTiff";
import ConvertSvgToIco from "@/pages/ConvertSvgToIco";
import ConvertSvgToWebp from "@/pages/ConvertSvgToWebp";
import ConvertPngToSvg from "@/pages/ConvertPngToSvg";
import ConvertPngToJpeg from "@/pages/ConvertPngToJpeg";
import ConvertJpgToSvg from "@/pages/ConvertJpgToSvg";
import ConvertWebpToSvg from "@/pages/ConvertWebpToSvg";
import ConvertTiffToSvg from "@/pages/ConvertTiffToSvg";
import ConvertIcoToSvg from "@/pages/ConvertIcoToSvg";
import ConvertSvgToJpeg from "@/pages/ConvertSvgToJpeg";
import ConvertHeicToJpeg from "@/pages/ConvertHeicToJpeg";
import ConvertBmpToSvg from "@/pages/ConvertBmpToSvg";
import ConvertJpgToHeic from "@/pages/ConvertJpgToHeic";
import ConvertPngToHeic from "@/pages/ConvertPngToHeic";
import ConvertWebpToHeic from "@/pages/ConvertWebpToHeic";
import ConvertSvgToHeic from "@/pages/ConvertSvgToHeic";
import ConvertBmpToHeic from "@/pages/ConvertBmpToHeic";
import ConvertTiffToHeic from "@/pages/ConvertTiffToHeic";
import ConvertIcoToHeic from "@/pages/ConvertIcoToHeic";
import ImageToText from "@/pages/ImageToText";
import PdfToText from "@/pages/PdfToText";
import TextToPdf from "@/pages/TextToPdf";
import PdfMerge from "@/pages/PdfMerge";
import PdfSplit from "@/pages/PdfSplit";
import ResizeByPercentage from "@/pages/ResizeByPercentage";
import ResizeForSocialMedia from "@/pages/ResizeForSocialMedia";
import ResizeForInstagram from "@/pages/ResizeForInstagram";
import ResizeForFacebook from "@/pages/ResizeForFacebook";
import ResizeForYouTube from "@/pages/ResizeForYouTube";
import ResizeForTwitter from "@/pages/ResizeForTwitter";
import ResizeForLinkedIn from "@/pages/ResizeForLinkedIn";
import ResizeForTikTok from "@/pages/ResizeForTikTok";
import ResizeForPinterest from "@/pages/ResizeForPinterest";
import ResizeToA4 from "@/pages/ResizeToA4";
import ImagesToPdf from "@/pages/ImagesToPdf";
import { JpgToPdf, PngToPdf, WebpToPdf, HeicToPdf, SvgToPdf, TiffToPdf } from "@/pages/SingleImageToPdf";
import TextToPdfNew from "@/pages/TextToPdfNew";
import MarkdownToPdf from "@/pages/MarkdownToPdf";
import { 
  WordToPdf, DocxToPdf, DocToPdf,
  PowerpointToPdf, PptxToPdf, PptToPdf,
  ExcelToPdf, XlsxToPdf, XlsToPdf,
  OdtToPdf, OdpToPdf, OdsToPdf, OdgToPdf,
  RtfToPdf, EpubToPdf 
} from "@/pages/DocumentToPdf";
import CompressPdf from "@/pages/CompressPdf";
import PdfToImages from "@/pages/PdfToImages";
import EditPdf from "@/pages/EditPdf";
import SignPdf from "@/pages/SignPdf";
import UnlockPdf from "@/pages/UnlockPdf";
import RemovePdfPages from "@/pages/RemovePdfPages";
import RearrangePdfPages from "@/pages/RearrangePdfPages";
import WatermarkPdf from "@/pages/WatermarkPdf";
import WebpageToPdf from "@/pages/WebpageToPdf";
import ExtractPdfPages from "@/pages/ExtractPdfPages";
import ProtectPdf from "@/pages/ProtectPdf";
import RotatePdf from "@/pages/RotatePdf";
import FlattenPdf from "@/pages/FlattenPdf";
import ComparePdf from "@/pages/ComparePdf";
import { 
  PdfToDocx, PdfToPptx, PdfToXlsx, PdfToOdt, PdfToRtf, 
  PdfToTxt, PdfToHtml, PdfToEpub, PdfToPdfa 
} from "@/pages/PdfConvert";
import { PdfToPng, PdfToJpg } from "@/pages/PdfToImage";
import PdfToSvg from "@/pages/PdfToSvg";
import PdfToSecure from "@/pages/PdfToSecure";
import MergeDocsToPdf from "@/pages/MergeDocsToPdf";
import DynamicPage from "@/pages/DynamicPage";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import AdminLogin from "@/pages/admin/Login";
import AdminLayout from "@/pages/admin/Layout";
import AdminDashboard from "@/pages/admin/Dashboard";
import PagesList from "@/pages/admin/PagesList";
import PageEditor from "@/pages/admin/PageEditor";
import PostsList from "@/pages/admin/PostsList";
import PostEditor from "@/pages/admin/PostEditor";
import MenusPage from "@/pages/admin/Menus";
import SettingsPage from "@/pages/admin/Settings";
import SidebarBuilder from "@/pages/admin/Sidebar";

// Protected route wrapper
function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen bg-slate-900 flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-2 border-blue-600 border-t-transparent"></div>
      </div>
    );
  }
  
  if (!user) {
    return <Navigate to="/admin/login" replace />;
  }
  
  return children;
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Static Routes - Must be defined first */}
          <Route path="/" element={<App />} />
          <Route path="/quick-50kb" element={<QuickCompress />} />
          <Route path="/quick-100kb" element={<QuickCompress100 />} />
          <Route path="/quick-200kb" element={<QuickCompress200 />} />
          <Route path="/quick-500kb" element={<QuickCompress500 />} />
          <Route path="/quick-1mb" element={<QuickCompress1MB />} />
          <Route path="/whatsapp-compress" element={<WhatsAppCompress />} />
          
          {/* Resize Image Tools */}
          <Route path="/resize-image-to-50kb" element={<ResizeImage50KB />} />
          <Route path="/resize-image-to-100kb" element={<ResizeImage100KB />} />
          <Route path="/resize-image-to-200kb" element={<ResizeImage200KB />} />
          <Route path="/resize-image-to-2mb" element={<ResizeImage2MB />} />
          <Route path="/resize-image-to-300x300" element={<ResizeImage300x300 />} />
          <Route path="/resize-image-for-whatsapp" element={<ResizeForWhatsApp />} />
          
          {/* Image Format Conversion Tools */}
          <Route path="/convert-jpg-to-png" element={<ConvertJpgToPng />} />
          <Route path="/convert-png-to-jpg" element={<ConvertPngToJpg />} />
          <Route path="/convert-png-to-webp" element={<ConvertPngToWebp />} />
          <Route path="/convert-jpg-to-webp" element={<ConvertJpgToWebp />} />
          <Route path="/convert-png-to-bmp" element={<ConvertPngToBmp />} />
          <Route path="/convert-png-to-tiff" element={<ConvertPngToTiff />} />
          <Route path="/convert-png-to-ico" element={<ConvertPngToIco />} />
          <Route path="/convert-jpg-to-jpeg" element={<ConvertJpgToJpeg />} />
          <Route path="/convert-jpg-to-bmp" element={<ConvertJpgToBmp />} />
          <Route path="/convert-jpg-to-tiff" element={<ConvertJpgToTiff />} />
          <Route path="/convert-jpg-to-ico" element={<ConvertJpgToIco />} />
          <Route path="/convert-bmp-to-png" element={<ConvertBmpToPng />} />
          <Route path="/convert-bmp-to-jpg" element={<ConvertBmpToJpg />} />
          <Route path="/convert-bmp-to-jpeg" element={<ConvertBmpToJpeg />} />
          <Route path="/convert-bmp-to-tiff" element={<ConvertBmpToTiff />} />
          <Route path="/convert-bmp-to-webp" element={<ConvertBmpToWebp />} />
          <Route path="/convert-bmp-to-ico" element={<ConvertBmpToIco />} />
          {/* TIFF Conversion Tools */}
          <Route path="/convert-tiff-to-png" element={<ConvertTiffToPng />} />
          <Route path="/convert-tiff-to-jpg" element={<ConvertTiffToJpg />} />
          <Route path="/convert-tiff-to-jpeg" element={<ConvertTiffToJpeg />} />
          <Route path="/convert-tiff-to-bmp" element={<ConvertTiffToBmp />} />
          <Route path="/convert-tiff-to-webp" element={<ConvertTiffToWebp />} />
          <Route path="/convert-tiff-to-ico" element={<ConvertTiffToIco />} />
          {/* WebP Conversion Tools */}
          <Route path="/convert-webp-to-png" element={<ConvertWebpToPng />} />
          <Route path="/convert-webp-to-jpg" element={<ConvertWebpToJpg />} />
          <Route path="/convert-webp-to-jpeg" element={<ConvertWebpToJpeg />} />
          <Route path="/convert-webp-to-bmp" element={<ConvertWebpToBmp />} />
          <Route path="/convert-webp-to-tiff" element={<ConvertWebpToTiff />} />
          <Route path="/convert-webp-to-ico" element={<ConvertWebpToIco />} />
          {/* ICO Conversion Tools */}
          <Route path="/convert-ico-to-png" element={<ConvertIcoToPng />} />
          <Route path="/convert-ico-to-jpg" element={<ConvertIcoToJpg />} />
          <Route path="/convert-ico-to-jpeg" element={<ConvertIcoToJpeg />} />
          <Route path="/convert-ico-to-bmp" element={<ConvertIcoToBmp />} />
          <Route path="/convert-ico-to-tiff" element={<ConvertIcoToTiff />} />
          <Route path="/convert-ico-to-webp" element={<ConvertIcoToWebp />} />
          {/* HEIC Conversion Tools */}
          <Route path="/convert-heic-to-jpg" element={<ConvertHeicToJpg />} />
          <Route path="/convert-heic-to-png" element={<ConvertHeicToPng />} />
          <Route path="/convert-heic-to-bmp" element={<ConvertHeicToBmp />} />
          <Route path="/convert-heic-to-tiff" element={<ConvertHeicToTiff />} />
          <Route path="/convert-heic-to-ico" element={<ConvertHeicToIco />} />
          <Route path="/convert-heic-to-webp" element={<ConvertHeicToWebp />} />
          <Route path="/convert-heic-to-svg" element={<ConvertHeicToSvg />} />
          {/* SVG Conversion Tools */}
          <Route path="/convert-svg-to-png" element={<ConvertSvgToPng />} />
          <Route path="/convert-svg-to-jpg" element={<ConvertSvgToJpg />} />
          <Route path="/convert-svg-to-jpeg" element={<ConvertSvgToJpeg />} />
          <Route path="/convert-svg-to-bmp" element={<ConvertSvgToBmp />} />
          <Route path="/convert-svg-to-tiff" element={<ConvertSvgToTiff />} />
          <Route path="/convert-svg-to-ico" element={<ConvertSvgToIco />} />
          <Route path="/convert-svg-to-webp" element={<ConvertSvgToWebp />} />
          {/* Vectorization Tools (X to SVG) */}
          <Route path="/convert-png-to-svg" element={<ConvertPngToSvg />} />
          <Route path="/convert-png-to-jpeg" element={<ConvertPngToJpeg />} />
          <Route path="/convert-jpg-to-svg" element={<ConvertJpgToSvg />} />
          <Route path="/convert-webp-to-svg" element={<ConvertWebpToSvg />} />
          <Route path="/convert-tiff-to-svg" element={<ConvertTiffToSvg />} />
          <Route path="/convert-ico-to-svg" element={<ConvertIcoToSvg />} />
          <Route path="/convert-bmp-to-svg" element={<ConvertBmpToSvg />} />
          <Route path="/convert-heic-to-jpeg" element={<ConvertHeicToJpeg />} />
          {/* X to HEIC Conversion Tools */}
          <Route path="/convert-jpg-to-heic" element={<ConvertJpgToHeic />} />
          <Route path="/convert-png-to-heic" element={<ConvertPngToHeic />} />
          <Route path="/convert-webp-to-heic" element={<ConvertWebpToHeic />} />
          <Route path="/convert-svg-to-heic" element={<ConvertSvgToHeic />} />
          <Route path="/convert-bmp-to-heic" element={<ConvertBmpToHeic />} />
          <Route path="/convert-tiff-to-heic" element={<ConvertTiffToHeic />} />
          <Route path="/convert-ico-to-heic" element={<ConvertIcoToHeic />} />
          {/* Document Tools */}
          <Route path="/image-to-text" element={<ImageToText />} />
          <Route path="/pdf-to-text" element={<PdfToText />} />
          <Route path="/text-to-pdf" element={<TextToPdf />} />
          <Route path="/pdf-merge" element={<PdfMerge />} />
          <Route path="/pdf-split" element={<PdfSplit />} />
          {/* Resize Tools */}
          <Route path="/resize-by-percentage" element={<ResizeByPercentage />} />
          <Route path="/resize-for-social-media" element={<ResizeForSocialMedia />} />
          <Route path="/resize-for-instagram" element={<ResizeForInstagram />} />
          <Route path="/resize-for-facebook" element={<ResizeForFacebook />} />
          <Route path="/resize-for-youtube" element={<ResizeForYouTube />} />
          <Route path="/resize-for-twitter" element={<ResizeForTwitter />} />
          <Route path="/resize-for-linkedin" element={<ResizeForLinkedIn />} />
          <Route path="/resize-for-tiktok" element={<ResizeForTikTok />} />
          <Route path="/resize-for-pinterest" element={<ResizeForPinterest />} />
          <Route path="/resize-to-a4" element={<ResizeToA4 />} />
          
          {/* PDF Conversion Tools */}
          <Route path="/images-to-pdf" element={<ImagesToPdf />} />
          <Route path="/jpg-to-pdf" element={<JpgToPdf />} />
          <Route path="/png-to-pdf" element={<PngToPdf />} />
          <Route path="/webp-to-pdf" element={<WebpToPdf />} />
          <Route path="/heic-to-pdf" element={<HeicToPdf />} />
          <Route path="/svg-to-pdf" element={<SvgToPdf />} />
          <Route path="/tiff-to-pdf" element={<TiffToPdf />} />
          <Route path="/text-to-pdf-new" element={<TextToPdfNew />} />
          <Route path="/markdown-to-pdf" element={<MarkdownToPdf />} />
          
          {/* Document to PDF Conversion Tools */}
          <Route path="/word-to-pdf" element={<WordToPdf />} />
          <Route path="/docx-to-pdf" element={<DocxToPdf />} />
          <Route path="/doc-to-pdf" element={<DocToPdf />} />
          <Route path="/powerpoint-to-pdf" element={<PowerpointToPdf />} />
          <Route path="/pptx-to-pdf" element={<PptxToPdf />} />
          <Route path="/ppt-to-pdf" element={<PptToPdf />} />
          <Route path="/excel-to-pdf" element={<ExcelToPdf />} />
          <Route path="/xlsx-to-pdf" element={<XlsxToPdf />} />
          <Route path="/xls-to-pdf" element={<XlsToPdf />} />
          <Route path="/odt-to-pdf" element={<OdtToPdf />} />
          <Route path="/odp-to-pdf" element={<OdpToPdf />} />
          <Route path="/ods-to-pdf" element={<OdsToPdf />} />
          <Route path="/odg-to-pdf" element={<OdgToPdf />} />
          <Route path="/rtf-to-pdf" element={<RtfToPdf />} />
          <Route path="/epub-to-pdf" element={<EpubToPdf />} />
          
          {/* PDF Manipulation Tools */}
          <Route path="/compress-pdf" element={<CompressPdf />} />
          <Route path="/pdf-to-images" element={<PdfToImages />} />
          <Route path="/edit-pdf" element={<EditPdf />} />
          <Route path="/sign-pdf" element={<SignPdf />} />
          <Route path="/unlock-pdf" element={<UnlockPdf />} />
          <Route path="/remove-pdf-pages" element={<RemovePdfPages />} />
          <Route path="/rearrange-pdf-pages" element={<RearrangePdfPages />} />
          <Route path="/watermark-pdf" element={<WatermarkPdf />} />
          <Route path="/webpage-to-pdf" element={<WebpageToPdf />} />
          <Route path="/extract-pdf-pages" element={<ExtractPdfPages />} />
          <Route path="/protect-pdf" element={<ProtectPdf />} />
          <Route path="/rotate-pdf" element={<RotatePdf />} />
          <Route path="/flatten-pdf" element={<FlattenPdf />} />
          <Route path="/compare-pdf" element={<ComparePdf />} />
          
          {/* PDF to X Conversion Tools */}
          <Route path="/pdf-to-docx" element={<PdfToDocx />} />
          <Route path="/pdf-to-word" element={<PdfToDocx />} />
          <Route path="/pdf-to-pptx" element={<PdfToPptx />} />
          <Route path="/pdf-to-powerpoint" element={<PdfToPptx />} />
          <Route path="/pdf-to-xlsx" element={<PdfToXlsx />} />
          <Route path="/pdf-to-excel" element={<PdfToXlsx />} />
          <Route path="/pdf-to-odt" element={<PdfToOdt />} />
          <Route path="/pdf-to-rtf" element={<PdfToRtf />} />
          <Route path="/pdf-to-txt" element={<PdfToTxt />} />
          <Route path="/pdf-to-html" element={<PdfToHtml />} />
          <Route path="/pdf-to-epub" element={<PdfToEpub />} />
          <Route path="/pdf-to-pdfa" element={<PdfToPdfa />} />
          <Route path="/pdf-to-png" element={<PdfToPng />} />
          <Route path="/pdf-to-jpg" element={<PdfToJpg />} />
          <Route path="/pdf-to-svg" element={<PdfToSvg />} />
          <Route path="/pdf-to-secure" element={<PdfToSecure />} />
          <Route path="/merge-documents-to-pdf" element={<MergeDocsToPdf />} />
          
          {/* Admin Routes */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={
            <ProtectedRoute>
              <AdminLayout />
            </ProtectedRoute>
          }>
            <Route index element={<AdminDashboard />} />
            <Route path="pages" element={<PagesList />} />
            <Route path="pages/:id" element={<PageEditor />} />
            <Route path="posts" element={<PostsList />} />
            <Route path="posts/:id" element={<PostEditor />} />
            <Route path="menus" element={<MenusPage />} />
            <Route path="sidebar" element={<SidebarBuilder />} />
            <Route path="settings" element={<SettingsPage />} />
          </Route>
          
          {/* Dynamic Page/Post Route - Catch all for custom slugs */}
          <Route path="/:slug" element={<DynamicPage />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  </React.StrictMode>,
);

